export default __webpack_public_path__ + "static/media/Group1497-Yono@2x.7f99d531.png";